export enum CookieKeys {
  'TOKEN_CONTEXT' = 'TOKEN_CONTEXT_AMBASSADOR',
}

export enum CookieDomain {
  'PHYSICSWALLAH_LIVE' = '.physicswallah.live',
}

const Config = {
  [CookieKeys.TOKEN_CONTEXT]: {
    expiryInSeconds: 60 * 60 * 24 * 7,
    domainsToShare: 'pw.live',
  },
}
export const getValue = (key: CookieKeys) => {
  let name = key + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      const val = c.substring(name.length, c.length)
      if (val) {
        return JSON.parse(val)
      }
      return ''
    }
  }
  return ''
}
export const setValue = (key: CookieKeys, data: any = '') => {
  const _config = Config[key]
  if (_config) {
    document.cookie = `${key}=${JSON.stringify(data)}; expires=${new Date(
      new Date().getTime() + _config.expiryInSeconds * 1000
    ).toUTCString()}; domain:${_config.domainsToShare}`
  }
}

const deleteCookie = (name: string, domain: string) => {
  document.cookie = `${name}=; path=/; domain=${domain}; expires=${new Date(
    0
  ).toUTCString()}`
}

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i]
    let eqPos = cookie.indexOf('=')
    let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}

export const CookieService = {
  setValue,
  getValue,
  deleteCookie,
  deleteAllCookies,
}
